const styles = theme => ({
  submittedTitle: {
    color: theme.palette.primary.default
  },
  noPostsContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translateY(-50%) translateX(-50%)"
  },
  noPostsText: {
    marginTop: theme.spacing(6),
    textAlign: "center",
    color: theme.palette.primary.default,
    fontSize: "26px"
  },
  infiniteScroll: {
    overflow: "hidden !important"
  },
  gridContainer: {
    flexDirection: "row",
    justifyContent: "flex-start",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center"
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/pages/App/Submitted/styles.js